import { api } from "./configs/axiosConfigs"

export const ReferenceDocumentsAPI = {

    getReferenceDocuments: async (data:any) => {
        const response = await api.get(
            '/referenceDocument', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createReferenceDocument: async (data: any) => {
        const response = await api.post(
            '/referenceDocument/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editReferenceDocument: async (idreference: number, data: any) => {
        const response = await api.patch(
            `/referenceDocument/${idreference}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteReferenceDocument: async (idreference: number) => {
        const response = await api.delete(
            `/referenceDocument/${idreference}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}